module.exports = __webpack_public_path__ + "media/slide1/contractMediaSlide1Part3-50c20bc2.png";